// @flow
export const WAG_API_ENDPOINT_DOG_ADD = 'dog';
export const WAG_API_ENDPOINT_V4_DOG_ADD = 'api/v4/dog';
export const WAG_API_ENDPOINT_DOG_UPDATE = 'dog/update';
export const WAG_API_ENDPOINT_OWNER_DETAILS = 'owner/details';
export const WAG_API_ENDPOINT_OWNER_REGISTER = 'owner/register';
export const WAG_API_ENDPOINT_PAYMENT_METHOD_ADD = 'owner/paymentmethod';
export const WAG_API_ENDPOINT_VACCINATION_ADD = 'vaccination';
export const WAG_API_ENDPOINT_VACCINES_GET = 'vaccination';

export const WAG_API_ENDPOINT_VETERINARIAN_ADD = 'api/v4/veterinarian';
export const WAG_API_ENDPOINT_VET_DOG_ASSOCIATION = ({
  dogId,
  vetId,
}: {
  dogId: number,
  vetId: number,
}) => `api/v4/dog/${dogId}/veterinarian/${vetId}`;

export const WAG_API_ENDPOINT_WAG_TAG_ORDER = 'wag_tag/order/guest';
export const WAG_API_ENDPOINT_SHELTER_ORDER = 'wag_tag/order/shelter';
export const WAG_API_ENDPOINT_WAG_TAG_REGISTER = 'wag_tag';
export const WAG_API_ENDPOINT_WAG_TAG_UPDATE = ({
  ownerId,
  wagTagSerialNumber,
}: {
  ownerId: number,
  wagTagSerialNumber: string,
}) => `owner/${ownerId}/wag_tag/${wagTagSerialNumber}`;
export const WAG_API_ENDPOINT_WAG_TAG_CONTACT_ADD = ({
  wagTagSerialNumber,
}: {
  wagTagSerialNumber: number,
}) => `wag_tag/${wagTagSerialNumber}/backup_contacts`;
export const WAG_API_ENDPOINT_WAG_TAG_MANAGE_PLAN = ({
  ownerId,
  wagTagSerialNumber,
}: {
  ownerId: number,
  wagTagSerialNumber: number,
}) => `owner/${ownerId}/wag_tag/${wagTagSerialNumber}/manage_plan`;

export const WAG_API_ENDPOINT_DOGS_GET = ({
  ownerId,
}: {
  ownerId: number,
}) => `api/v4/owner/${ownerId}/dogs`;

export const WAG_API_ENDPOINT_UPDATE_APP_VERSION = 'v3/owner/update_app_version';

export const WAG_API_ENDPOINT_WAG_TAG_DETAILS_GET = (tagSerialNumber: string) => `v2/wag_tag/${tagSerialNumber}`;
export const WAG_API_ENDPOINT_WAG_TAG_INFO_GET = 'v2/wag_tag';

export const WAG_API_ENDPOINT_LOGIN = 'rest/v1/auth/owner/login';
export const WAG_API_ENDPOINT_RESET_PASSWORD_EMAIL = 'owner/reset-password-email';
export const WAG_API_ENDPOINT_UPDATE_PASSWORD = 'owner/changepassword';
